const wrapper = "_araw1cvo4c9";
const contextMenu = "_arac71azl7";
const button = "_arabuvrzvq";
const heading = "_arahd0ys10";
const description = "_arad5bnqh8";
const expandChevron = "_araeox8n6s";
const expandIconWrapper = "_arae14rujup";

export { button, contextMenu, description, expandChevron, expandIconWrapper, heading, wrapper };
import "./finished.card.style.linaria.module.css";
//# sourceMappingURL=finished.card.style.js.map
